<template>
  <Icon
    v-if="certainty && [1, 2, 3, 4].includes(certainty)"
    icon="feather:check-circle"
    :title="title"
    :style="{ color }"
  />
  <Icon v-else icon="feather:check-circle" class="invisible" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Icon } from "@iconify/vue";

const props = defineProps<{ certainty?: number | null }>();

const titles: { [key: number]: string } = {
  1: "Diagnosis possible",
  2: "Diagnosis probable",
  3: "Diagnosis almost certain",
  4: "Diagnosis certain",
};

const colors: { [key: number]: string } = {
  1: "#9c9c9c",
  2: "#efca00",
  3: "#149114",
  4: "#3095d8",
};

const color = computed(() => (props.certainty ? colors[props.certainty] : ""));
const title = computed(() => (props.certainty ? titles[props.certainty] : ""));
</script>
